// import node module libraries
import {Fragment, useEffect, useState} from 'react';
import { Breadcrumb, Card, Col, Row, Tab } from 'react-bootstrap';

// import custom components
import GridListViewButton from 'components/elements/miscellaneous/GridListViewButton';

// import sub components
import OldStudentsGridCard from './OldStudentsGridCard';
import OldStudentsListItems from './OldStudentsListItems';
import { Link } from 'react-router-dom';
import EleveService from '../../services/EleveService';

const OldStudents = () => {
	const [old_students, setOldStudents] = useState([]);

	useEffect(() => {
		EleveService.getAllNonActiveEleves().then((response) => {
			setOldStudents(response);
		});
	}, []);

	return (
		<Fragment>
			<Tab.Container defaultActiveKey="list">
				<Row>
					<Col lg={12} md={12} sm={12}>
						<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
							<div className="mb-3 mb-md-0">
								<h1 className="mb-1 h2 fw-bold">
									Anciens Elèves{' '}
									<span className="fs-5 text-muted"> ({old_students.length})</span>
								</h1>
								<Breadcrumb>
									<Breadcrumb.Item href="/">
										Accueil
									</Breadcrumb.Item>
									<Breadcrumb.Item active>Anciens Elèves</Breadcrumb.Item>
								</Breadcrumb>
							</div>
							<div className="d-flex align-items-center justify-content-between">
								<GridListViewButton keyGrid="grid" keyList="list" />
							</div>
						</div>
					</Col>
				</Row>

				<Tab.Content>
					<Tab.Pane eventKey="grid" className="pb-4">
						{/* old_students in list view */}
						<OldStudentsGridCard />
						{/* end of old_students in list view */}
					</Tab.Pane>
					<Tab.Pane eventKey="list" className="pb-4">
						<Card className="mb-5 ">
							<Card.Body className="p-0">
								{/* old_students in list view */}
								<OldStudentsListItems />
								{/* end of old_students in list view */}
							</Card.Body>
						</Card>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Fragment>
	);
};
export default OldStudents;
